import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Globals } from '../../globals';
import { ProIconGroups } from '../../interfaces/pro/pro-icon-group.interface';

@Injectable({
  providedIn: 'root',
})
export class ProIconGroupsService {
  private readonly http = inject(HttpClient);
  private readonly globals = inject(Globals);

  private url = this.globals.apiRoot + '/JwtProIconGroup';

  getAll(): Observable<ProIconGroups> {
    return this.http.get<ProIconGroups>(this.url);
  }
}
